export default __webpack_public_path__ + "static/media/todo.a4d5fee3.mp4";